export default {
	data() {
		return {
			projectFinanceTable: 'conditions',
			forDeveloperRKOCityId: 32,
		}
	}
}
